module.exports = __webpack_public_path__ + "static/media/loader-car.d4ffcbcb.gif";